import { useQuery } from "@tanstack/react-query";

import { apiClient } from "@/api/client";

export interface PaymentChannelOption {
  value: string;
  count: number;
}

/**
 * Distinct payment channels present in orders, for the payment channel filter dropdown.
 */
export function usePaymentChannels() {
  return useQuery({
    queryKey: ["order-payment-channels"],
    queryFn: async (): Promise<PaymentChannelOption[]> => {
      const { data, error } = await apiClient.GET("/v1/orders/payment-channels", {});
      if (error) throw error;
      return data?.data ?? [];
    },
    staleTime: 5 * 60_000,
  });
}
